export const NEW_ACCESS = "New Access";
export class NewAccessRequest {
  readonly type = NEW_ACCESS;
  readonly id = 1;
}

export const MODIFY_ACCESS = "Modify Access";
export class ModifyAccessRequest {
  readonly type = MODIFY_ACCESS;
  readonly id = 2;
}

export const REVOKE_ACCESS = "Revoke Access";
export class RevokeAccessRequest {
  readonly type = REVOKE_ACCESS;
  readonly id = 3;
}

export type RequestType =
  | NewAccessRequest
  | ModifyAccessRequest
  | RevokeAccessRequest;

export enum RevokeType {
  UNNECESSARY_ACCESS = "Unnecessary Access",
}

export interface ErrorResponse {
  index: number;
  errorCode: string;
  errorMessage: string;
}

export interface CreateRequestResponse {
  success: boolean;
  referenceNumbers: string[];
  errors: ErrorResponse[];
}

export interface Request {
  requestType: string;
  requestTypeId: number;
  revokeType: RevokeType | null;
  effectiveDate: string;
  justification: string;
  attestation: string;
  draftKey: string;
  requests: RequestItem[];
}

export interface RequestItem {
  isAdvance: boolean; //is before employee started
  startDate: string | null; //start date for employee if isAdvance
  accessDetail: string; //what the user typed in for "access details"
  categoryId: number; //app.categoryId,
  deviceTypeAppId: number; //if app.isManual and "infrastructure application" dropdown had data, then the id from the selected option. Otherwise, 0
  deviceTypeId: number; //app.id,
  environmentId: number; //environment.id
  role: string; //if app.isManual, then the role textbox field. If !app.isManual, then role.name
  roleId: number; //if app.isManual, then 0, if !app.isManual, then role.id
  subCategoryId: number; //app.subCategoryId
  subCategoryName: string; //app.name
  systemTypeId: number; //app.systemTypeId
  userEmail: string;
  userId: string;
  userName: string;
  infrastructureDetails?: {
    environmentId: number; // infra app env id
    role: string;
    accessDetails: string;
    subCategoryName: string;
  }[];
  form?: {
    [key: string]: any;
  };
}

export interface RequestForAttestation {
  referenceNumber: string;
  encryptId: string;
}

export interface RequestDetailsForApprovalResponse {
  viewRole: string;
  request: RequestDetailsForApproval;
}

export interface RequestDetailsForApproval {
  id: number;
  referenceNumber: string | null;
  status: string | null;
  isSendBack: boolean;
  requestor: string | null;
  requestorEmail: string | null;
  requestorTelephoneNumber: string | null;
  requestorOffice: string | null;
  revokeType: string | null;
  effectiveDate: string | null;
  dateAdded: string | null;
  justification: string | null;
  userEmail: string | null;
  userName: string | null;
  attestationName: string;
  userID: string | null;
  requestType: string | null;
  category: string | null;
  subCategory: string | null;
  role: string | null;
  environment: string | null;
  uamNote: string | null;
  isAdvance: boolean;
  isMobileAttestation: boolean;
  advanceDate: string | null;
  serviceTicketNumber: string | null;
  autoReject: boolean;
  isAttestationNeeded: boolean | null;
  isAttestationSigned: boolean;
  accessRequests: AccessRequestResponse[];
  approvers: ApproversResponse[];
  formId_?: number;
  isDelegate?: boolean;
}

export interface AccessRequestResponse {
  id?: number;
  userName: string;
  subCategory: string;
  deviceType: string;
  appName: string;
  role: string;
  environment: string;
  approvalStatus: string;
  accessJustification: string;
  additionalForm?: {
    apMisOnline?: any;
    cyberSourceForm?: any;
    formFinance?: any;
    gsapForm?: any;
    formKiteworks?: any;
    localPCAdminExceptionForm?: any;
    migs?: any;
    removableMediaExceptionAuthorization?: any;
    risknetForm?: any;
    salesforceForm?: any;
    sharedDriveForm?: any;
    formThirdParty?: any;
    upopAcquirerPortalOperatorPrivilegeForm?: any;
    formWinscp?: any;
    workday?: any;
  };
  formId?: number;
  formId_?: number;
}

export interface ApproversResponse {
  deviceType: string | null;
  level: string | null;
  subCategory: string | null;
  approver1: string | null;
  approvedBy1: string | null;
  approvalDistroName1: string | null;
  approver2: string | null;
  approvedBy2: string | null;
  approvalDistroName2: string | null;
  approver3: string | null;
  approvedBy3: string | null;
  approvalDistroName3: string | null;
  approver4: string | null;
  approvedBy4: string | null;
  approvalDistroName4: string | null;
  approverDistro2: number;
  approverDistro3: number;
  approverDistro4: number;
}

export interface UpdateApprovers {
  approver1: string | null;
  approver2: string | null;
  approver3: string | null;
  approver4: string | null;
}

export interface RequestResponse {
  id: number;
  referenceNumber: string;
  rfNo?: string;
  encryptId: string;
  requestor: string;
  effectiveDate: string;
  dateAdded: string;
  userName: string;
  category: string;
  deviceType: string;
  subCategory: string;
  environment: string;
  roleName: string;
  role: string;
  justification: string;
  requestType: string;
  isSendBack: boolean;
  status: string;
  userEmail: string;
  systemType: string; // Business Unit
  serviceTicketNumber: string;
}

export interface RequestLog {
  addedBy: string;
  dateTime: string;
  logType: string;
  remarks: string;
}
